import SongLoesung from "../../components/SongLoesung";
import "./LoesungHaltenOverlay.css";

/**
 * Loesung, solange "Loesung ansehen" gedrueckt ist (klassischer Modus).
 * Antippen schliesst ebenfalls — falls das Loslassen mal nicht ankommt,
 * haengt hier niemand fest.
 */
export default function LoesungHaltenOverlay({ isSongLoading, songData, onClose }) {
  return (
    <div className="halten-ebene" onPointerUp={onClose} onClick={onClose}>
      <div className="halten-sheet">
        <span className="halten-griff" aria-hidden="true" />
        <span className="ueberzeile">Nur für dich</span>
        <SongLoesung isSongLoading={isSongLoading} songData={songData} gross />
      </div>
      <p className="halten-finger">
        <span className="halten-punkt" aria-hidden="true" />
        Loslassen zum Schließen
      </p>
    </div>
  );
}
